<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      unit="用户信息"
      edit-title
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @details-opened="onDetailsOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="135px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="用户类型" prop="PersonType">
              <span v-if="data.PersonType == 0">个人用户</span>
              <span v-if="data.PersonType == 1">企业用户</span>
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="姓名" prop="PersonName">
              {{ data.PersonName }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="编号" prop="PersonCode">
              {{ data.PersonCode }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="性别" prop="PersonSex">
              <span v-if="data.PersonSex == 1">男</span>
              <span v-if="data.PersonSex == 0">女</span>
              <span v-if="data.PersonSex == 2">保密</span>
            </el-form-item>
          </el-col>
           <el-col :span="isMB ? 24 : 12" v-if="data.PersonType==1">
            <el-form-item label="联系人" prop="ContactName">
              {{ data.ContactName }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="手机号码" prop="ContactPhone">
              {{ data.ContactPhone }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="身份证号码" prop="PersonIdno">
              {{ data.PersonIdno }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="用户等级" prop="PersonGradeid">
              <el-select
                v-model="data.PersonGradeid"
                placeholder="请选择用户等级"
                clearable
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.RecordId"
                  :value="item.RecordId"
                  :label="item.GradeName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12" v-if="data.PersonType==1">
            <el-form-item label="统一社会信用代码" prop="LicenseCode">
              {{ data.LicenseCode }}
            </el-form-item>
          </el-col>
          <!--<el-col :span="isMB ? 24 : 12">
            <el-form-item label="会员标签" prop="PersonLabel">
              <el-input v-model="data.PersonLabel" placeholder="请选择会员标签" clearable></el-input>
            </el-form-item>
           </el-col> -->
        </el-row>

        <el-row v-if="false">
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="会员积分" prop="PersonPoints">
              <el-input
                v-model="data.PersonPoints"
                placeholder="请选择会员积分"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="isMB ? 24 : 12">
            <el-form-item label="会员余额" prop="PersonBalance">
              <el-input v-model="data.PersonBalance" placeholder="请选择会员余额" clearable></el-input>
            </el-form-item>
           </el-col> -->

          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="0">未实名</el-radio>
                <el-radio :label="1">已实名</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="file-form">
          <el-col :span="24">
            <el-form-item label="身份证照" prop="IdnoPhoto">
              <div>
                <el-upload
                  class="file-up"
                  :action="host + '/api/Common/UploadPicture'"
                  list-type="picture-card"
                  :show-file-list="true"
                  accept=".jpg,.png,"
                  :on-success="
                    (res, file, fileList) => {
                      onSuccess(res, file, fileList, 'IdnoPhoto');
                    }
                  "
                  :headers="headers"
                  :file-list="IdnoPhoto"
                  :limit="10"
                  :on-preview="handlePictureCardPreview"
                  :on-exceed="onExceed"
                  :before-upload="beforePhotoUpload"
                  :on-remove="
                    (file, fileList) => {
                      fileRemove(file, fileList, 'IdnoPhoto');
                    }
                  "
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-tooltip
                  class="upload-tip"
                  effect="light"
                  content="图片格式须为jpg、png, 可上传多图"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="file-form" v-if="data.PersonType==1">
          
          <el-col :span="isMB ? 24 : 12">
            <el-form-item
              :label="isMB ? '' : '营业执照'"
              :label-width="isMB ? '0' : ''"
              prop="LicensePhoto"
            >
              <el-divider v-if="isMB">营业执照</el-divider>
              <single-pic-upload
                v-model="data.LicensePhoto"
                type="LicensePhoto"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="营业执照" prop="LicensePhoto">
              <div>
                <el-upload
                  class="file-up"
                  :action="host + '/api/Common/UploadPicture'"
                  list-type="picture-card"
                  :show-file-list="true"
                  accept=".jpg,.png,"
                  :on-success="
                    (res, file, fileList) => {
                      onSuccess(res, file, fileList, 'LicensePhoto');
                    }
                  "
                  :headers="headers"
                  :file-list="LicensePhoto"
                  :limit="10"
                  :on-preview="handlePictureCardPreview"
                  :on-exceed="onExceed"
                  :before-upload="beforePhotoUpload"
                  :on-remove="
                    (file, fileList) => {
                      fileRemove(file, fileList, 'LicensePhoto');
                    }
                  "
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-tooltip
                  class="upload-tip"
                  effect="light"
                  content="图片格式须为jpg、png, 可上传多图"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col> -->
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item
              :label="isMB ? '' : '头像'"
              :label-width="isMB ? '0' : ''"
              prop="ProfilePhoto"
            >
              <el-divider v-if="isMB">头像</el-divider>
              <single-pic-upload
                v-model="data.ProfilePhoto"
                type="ProfilePhoto"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12" v-if="false">
            <el-form-item
              :label="isMB ? '' : '二维码'"
              :label-width="isMB ? '0' : ''"
              prop="QrCode"
            >
              <el-divider v-if="isMB">二维码</el-divider>
              <single-pic-upload
                v-model="data.QrCode"
                type="QrCode"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="注册时间" prop="RegisterTime">
              {{ data.RegisterTime }}
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="OpenId" prop="OpenId">
              {{ data.OpenId }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 16" style="padding-left: 17px">
            <div style="margin-bottom: 6px">审核日志</div>
            <el-table :data="tableData" border size="small">
              <el-table-column prop="UserName" label="操作人" />
              <el-table-column prop="OperResult" label="操作结果">
                <template slot-scope="{ row }">
                  <span v-if="row.OperResult == 1">提交</span>
                  <span v-else-if="row.OperResult == 2">通过</span>
                  <span v-else-if="row.OperResult == 3">不通过</span>
                  <span v-else-if="row.OperResult == 4">撤销审核</span>
                </template>
              </el-table-column>
              <el-table-column prop="OperMsg" label="备注" />
              <el-table-column prop="OperTime" label="操作时间" />
            </el-table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <template v-if="$permission.canReview()">
          <template v-if="data.State == 0">
            <el-button type="success" @click="pass">通 过</el-button>
            <el-button type="danger" @click="noPass">不通过</el-button>
          </template>
          <el-button type="warning" v-else-if="data.State == 1" @click="cancel"
            >撤销审核</el-button
          >
        </template>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
    <el-dialog :visible.sync="dialogVisible" title="查看图片" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
  },
  props: {},
  computed: {
    host() {
      return window.location.origin; //获取当前网站的域名，用于上传多图那里
    },
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OpenId: "",
        PersonCode: "",
        State: 0, //写道这里
        QrCode: "",
        ContactPhone: "",
        ProfilePhoto: "",
        NickName: "",
        PersonName: "",
        PersonSex: 1,
        PersonIdno: "",
        PersonGradeid: null,
        RegisterTime: this.$commonJs.getNowDatetimeString(),
        IdnoPhoto: "",
        PersonLabel: "",
        PersonPoints: null,
        PersonBalance: null,
        LicensePhoto: "",
        LicenseCode: "",
        PersonType: null,
        DataSource: 0,
        GradeName: "",
      },
      saveState: 0,
      gradeList: [],
      IdnoPhoto: [],
      LicensePhoto: [],
      tableData: [],
      dialogImageUrl: "",
      dialogVisible: false,
      api: require("@/api/person/personinfo").default,
      api2: require("@/api/person/persongrade").default,
      headers: { Authorization: "Bearer " + this.$commonJs.getCookie("token") }, //传图片时加上token
      isMB: this.$store.state.isMB,
      rules: {
        PersonName: [{ required: true, message: "姓名不能为空" }],
        //NickName: [{ required: true, message: "昵称不能为空" }],
        PersonSex: [{ required: true, message: "性别不能为空" }],
        PersonGradeid: [{ required: true, message: "用户等级不能为空" }],
        PersonType: [{ required: true, message: "用户类型不能为空" }],
        ContactPhone: [
          { required: true, message: "手机号码不能为空" },
          { validator: this.$commonJs.validateRules.validPhone },
        ],
        PersonIdno: [{ validator: this.$commonJs.validateRules.idCard }],

        //  ContactPhone: [{ validator: this.$commonJs.validateRules.validPhone2 }],
      },

      uploadUrl: "/api/Common/UploadPicture",
    };
  },
  methods: {
    onCreateOpened(data) {
      this.getOption();
    },
    onDetailsOpened(data) {
      this.getOption();
      console.log(data, "data");
      if (data.IdnoPhoto) {
        data.IdnoPhoto.split(",").forEach((e) => {
          this.IdnoPhoto.push({
            url: "/api" + e,
            url2: e,
          });
        });
      }
      if (data.LicensePhoto) {
        data.LicensePhoto.split(",").forEach((e) => {
          this.LicensePhoto.push({
            url: "/api" + e,
            url2: e,
          });
        });
      }
      this.api.getChecklogs({ PersonId: this.data.RecordId }).then((res) => {
        this.loading(false);
        if (res.Code == 0) this.tableData = res.Data;
      });
    },
    getOption() {
      this.loading(true);
      this.api2.list({ State: 1 }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.gradeList = res.Data;
        }
      });
    },
    beforePhotoUpload(file) {
      const is500k = file.size / 1024 <= 2048;
      if (!is500k) {
        this.$message.error("照片大小不能超过2M");
      }
      return is500k;
    },
    onSuccess(res, file, fileList, name) {
      if (res.Code == 0) {
        this[name].push({ url: "/api" + res.Data, url2: res.Data });
      } else {
        fileList.splice(fileList.length - 1, 1);
        this.$message.error(res.Msg);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    fileRemove(file, fileList, name) {
      var index = this[name].findIndex((x) => x.url == file.url);
      if (index > -1) {
        this[name].splice(index, 1);
      }
    },
    onExceed() {
      this.$message.error("超过上传数量限制");
    },

    onBeforeSave() {
      var place = "";
      this.IdnoPhoto.forEach((e, index) => {
        place += e.url2;
        if (index < this.IdnoPhoto.length - 1) {
          place += ",";
        }
      });
      this.data.IdnoPhoto = place;
      var place2 = "";
      this.LicensePhoto.forEach((e, index) => {
        place2 += e.url2;
        if (index < this.LicensePhoto.length - 1) {
          place2 += ",";
        }
      });
      this.data.LicensePhoto = place2;
    },
    onClosed() {
      this.gradeList = [];
      this.IdnoPhoto = [];
      this.LicensePhoto = [];
    },
    pass() {

      if(!this.data.PersonGradeid){
        this.$message.error("请选择用户等级");
        return false;
      }
var data=this.data;
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.pass(data).then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    noPass() {
     this.$prompt("请输入不通过原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",       
        dangerouslyUseHTMLString:true,
        inputPlaceholder: '请输入不通过原因'
      })
        .then(({ value }) => {
          this.loading(true);
          this.api.noPass({Id:this.data.RecordId,CheckMsg:value}).then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    cancel() {
      this.$confirm("确认撤销审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.cancelReview(this.data.RecordId).then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-tip {
  transform: translateY(26px);
  margin-left: 10px;
}
</style>
